export default __webpack_public_path__ + "static/media/orchard-black.069509dd.svg";